export const hiddenChapters = [
  "DisclaimerChapter",
  "CoverPageChapter",
  "ContentChapter"
];